import React, {Component, useState } from "react";
// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import WaitDialog from '../../../widgets/WaitDialog';
import EditFatturaInsegnanteWidget from '../../../widgets/EditFatturaInsegnanteWidget';
import moment from 'moment';
import addFattura from "../../../services/addFattura";
import editFattura from "../../../services/editFattura";
import getFatture from "../../../services/getFatture";

const qs = require('querystring');

export default class FattureInsegnante extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    this.fatture = [];

    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.selectRef = React.createRef();

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false,
      selectPdfDatesVisible: false,
      fusioneEnabled: false,
      insegnanti: [],
      gruppiInsegnantiComplete: [],
      mailCompaniesList: [],
      reportPeriod: '',
      waitDialogFileVisible: false,
      editFatturaWidget: false,
      fileReady: false
    }

    this.grid = 2;
    this.tableRef = React.createRef();
    this.editFatturaRef = React.createRef();

    this.pdfElements = [];

    this.insegnanti = [];
    this.gruppiInsegnantiComplete = [];
    this.pageTitle = "Fatture insegnanti";
    this.brokerId = undefined;

    const cookies = new Cookies();
    var strJson = JSON.stringify({list: []});
    cookies.set('checksList', strJson, { path: '/' });
    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

    this.state = {

    };

  }

  async reload(){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    const parsed = qs.parse(window.location.hash);
    let regime = parsed['#/billing/fattureInsegnanti?regime'];
    console.log(regime);
    
    this.fatture = await getFatture(username, token);

   if (regime !== 'all' && regime !== undefined) {
      this.fatture = this.fatture.filter((fattura) => fattura.regime === regime);
   }

    this.fatture = this.fatture.sort((l1, l2) => {
      var ll1 = moment(l1.data, "DD-MM-yyyy");
      var ll2 = moment(l2.data, "DD-MM-yyyy");
      return ll2 - ll1;
    });

    this.setState({
    });
  }

  async componentDidMount(){
    await this.reload();

  }

  render () {

    this.searchCols = ['nome', 'cognome', 'materie', 'mail'];
    this.searchColsGroups = ['nome', 'insegnanti'];

    this.tableRef.current && this.tableRef.current.clearSearch();

    return (
      <div id={Math.random()}>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={this.pageTitle} />

        <div>
        {
          this.fatture.map (fattura => {

            var regime = '';
            switch (fattura.regime) {
              case 'FAT_1': 
                regime = 'Dipendenti Showrestart';
                break;
              case 'FAT_2': 
                regime = 'Autonomi Regime Forfettario';
                break;
              case 'FAT_3': 
                regime = 'Autonomi Regime Ordinario';
                break;
              default:
                regime = 'Non definito';
                break;
            }

            return <div style={{border: '1px solid black', padding: '10px'}} onClick={
              () => {
                this.setState({currentFattura: fattura, editFatturaWidget: true});
                this.editFatturaRef.current.refresh(fattura);
              }
            }>
              <div><b>Nome</b>: {fattura.cognome + ' ' + fattura.nome}</div>
              <div><b>Data</b>: {fattura.data}</div>
              <div><b>Importo</b>: {fattura.importo}</div>
              <div><b>Regime</b>: {regime}</div>
              <div><b>Stato pagamento</b>: {fattura.flag_pagamento == 1 ? 'PAGATA' : 'NON PAGATA'}</div>
              <div><b>Note</b>: {fattura.note}</div>
            </div>
          })
        }

        </div>

        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>
        <EditFatturaInsegnanteWidget 
            ref={this.editFatturaRef}
            show={this.state.editFatturaWidget}
            fattura={this.state.currentFattura}
            onClose={async fattura => {
              if (fattura == undefined) {
                this.reload();
                this.setState({editFatturaWidget: false});
                return;
              }

              const cookies = new Cookies();
              const username = cookies.get('username', { path: '/' });
              const token = cookies.get('token', { path: '/' });
              const currentInsegnante = cookies.get('currentInsegnante', { path: '/' });
          
              if (fattura.id == undefined)
                await addFattura(username, token, currentInsegnante, fattura.data, fattura.importo, fattura.file, fattura.note, fattura.status == 'PAGATA' ? 1 : 0);
              else   
                await editFattura(username, token, fattura.id, fattura.id_insegnante, fattura.data, fattura.importo, fattura.file, fattura.note, fattura.status == 'PAGATA' ? 1 : 0);

              this.setState({editFatturaWidget: false});
              this.reload();
          }}
        />
        </LoadingOverlay>
      </div>
    );
  }
}

